<template>
  <div>
    <v-row class="mx-12">
      <v-tabs
        v-model="tab"
        class="pt-5"
        background-color="white"
        slider-color="var(--app-light-primary-color)"
        active-class="tab-active"
      >
        <v-tab
          v-for="tabButton in tabsButtons"
          :key="tabButton.href"
          class="tab-padding"
          :href="tabButton.href"
          @click="changeTab(tabButton)"
        >
          {{ tabButton.title }}
        </v-tab>
      </v-tabs>
      <v-col cols="12">
        <v-row>
          <v-col
            v-for="(session, index) in sessions"
            :key="index"
            cols="4"
          >
            <bankruptcy-card
              :info-item="session"
              :icon="'mdi-account-group'"
              :header="session.sessionType"
              :status=" session.sessionStatus"
              :status-display-name="local.caseFile.cards.session.statusDisplayName"
              :date="session.sessionDate"
              :date-display-name="local.caseFile.cards.session.dateDisplayName"
              :has-actions="false"
              :court-name="session.court"
              :sub-circle-name="session.subCircle"
              @card-click="viewAttachment(session)"
            >
              <template slot="bottom-slot">
                <div class="row px-2 header-text">
                  <div class="py-1  text-c-green col-4">
                    {{ local.caseFile.cards.session.codeDisplayName }}
                  </div>
                  <template
                    v-if="session.isVideoConference"
                  >
                    <div class="py-1  text-info-value col-8">
                      <v-icon
                        color="var(--app-primary-color)"
                        class="copy-icon mx-0"
                        left
                        @click="copyURL(session.videoConferenceUrl)"
                      >
                        mdi-content-copy
                      </v-icon>
                      <span class="text-info-value">{{ local.caseFile.cards.sessionTypes.videoSession }}</span>
                      <span
                        class="videoConferenceUrl"
                        @click="copyURL(session.videoConferenceUrl)"
                      > {{ local.home.upcomingSessions.copyLink }} </span>
                    </div>
                  </template>
                  <template
                    v-else-if="session.typeId == sessionTypes.remoteArgument"
                  >
                    <div class="py-1  text-info-value col-8">
                      <span class=" text-info-value">{{ local.caseFile.cards.sessionTypes.chatSession }}</span>
                    </div>
                  </template>
                  <template v-else>
                    <div class="py-1  text-info-value col-8">
                      <v-icon
                        v-if="session.typeId != sessionTypes.elitigationSession"
                        color="var(--app-primary-color)"
                        class="copy-icon mx-0"
                        left
                      >
                        mdi-map-marker
                      </v-icon>
                      <span class=" text-info-value">{{session.typeId == sessionTypes.elitigationSession ? local.caseFile.cards.sessionTypes.chatSession : local.caseFile.cards.sessionTypes.attendance }}</span>
                      <span class=" text-info-value"> {{ session.typeId != sessionTypes.elitigationSession ? local.home.upcomingSessions.courtLocation : '' }} </span>
                    </div>
                  </template>
                </div>
                <div
                  v-if="session.typeId != sessionTypes.elitigationSession"
                  class="row px-2 header-text">
                  <div class="py-1  text-c-green col-4">
                    {{ local.caseFile.cards.session.timeDisplayName }}
                  </div>
                  <div
                    v-if="session.appointmentStartDate && session.appointmentEndDate"
                    class="py-1  text-info-value col-8"
                  >
                    {{ getTime12Format(session.appointmentStartDate) }}{{ isAm(session.appointmentStartDate)? local.calendar.amShort: local.calendar.pmShort }}
                    -
                    {{ getTime12Format(session.appointmentEndDate) }}{{ isAm(session.appointmentEndDate)? local.calendar.amShort: local.calendar.pmShort }}
                    <span
                      v-if="session.appointmentDurationInMinutes"
                      class="text-c-lite"
                    >
                      ( {{ session.appointmentDurationInMinutes }}) {{ local.calendar.min }}
                    </span>
                  </div>
                  <div
                    v-else
                    class="py-1  text-info-value col-8"
                  >
                    --
                  </div>
                </div>
                <div
                  v-if="session.typeId == sessionTypes.elitigationSession"
                  class="row px-2 header-text">
                  <div class="py-1  text-c-green col-4">
                    {{ local.caseFile.cards.session.timeDisplayName }}
                  </div>
                  <div
                    v-if="session.appointmentStartDate && session.appointmentEndDate"
                    class="py-1  text-info-value col-8"
                  >
                    {{ getTwoDatesDifference(session.appointmentEndDate, session.appointmentStartDate)}}
                    {{ getTwoDatesDifference(session.appointmentEndDate, session.appointmentStartDate) > 1 ? local.bankruptcy.bankruptcyFile.sessions.elitigationSessions.days : local.bankruptcy.bankruptcyFile.sessions.elitigationSessions.day}}
                  </div>
                  <div
                    v-else
                    class="py-1  text-info-value col-8"
                  >
                    --
                  </div>
                </div>
              </template>
              <template
                v-if="session.typeId"
                slot="bottom-button-slot"
              >
                <div
                  v-if="session.typeId == sessionTypes.elitigationSession"
                  class="px-2 pa-3"
                >
                  <naj-button
                    color="primary"
                    @click="showELitigationSession(session)"
                    :disabled="session.sessionStatusId == sessionStatus.new"
                    >
                    {{ local.common.show }}
                  </naj-button>
                </div>
              </template>
            </bankruptcy-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <naj-no-data
          :has-data="sessions && sessions.length > 0"
          :loading="loading"
        >
        </naj-no-data>
      </v-col>
    </v-row>
    <pdf-modal
      v-if="selectedFile"
      ref="pdfModal"
      :file-name="selectedFile.fileName"
      :share-point-id="selectedFile.spid"
      @modalClose="hideViewAttachmentModal"
    >
    </pdf-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import BankruptcyCard from '../bankruptcy-card.vue';
import { sessionTypes, sessionStatus } from '@/helpers/enum';
import { identityTypeEnum } from '@/modules/bankruptcy/helpers/enum';
import { toHijriDate, getTimePartArabic, getTimePart, getTime12Format, isAm, getTimeSlot, getTwoDatesDifference } from '@/helpers/utils';
import PdfModal from '@/components/shared/pdf-modal/index.vue';
const { mapActions } = createNamespacedHelpers('BankruptcyModule');
const { mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');

export default {
  name: 'SessionsTab',
  components: {
    BankruptcyCard,
    PdfModal,
  },
  props: {
    requestObjectKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      selectedFile: null,
      sessions: [],
      sessionTypes,
      sessionStatus,
      toHijriDate,
      getTimePartArabic,
      getTimePart,
      getTime12Format,
      isAm,
      getTimeSlot,
      showAttendanceRegister: false,
      pledged: false,
      selectedSession: null,
      attendanceRegisterDisplay: false,
      identityTypeEnum,
      getTwoDatesDifference,
      elitigationSessionsEnabled: false,
      selectedTab: {},
      tab: null,
    };
  },
  computed: {
    ...mapGlobalState(['userInfo']),
    tabsButtons() {
      return [
        {
          href: '#tab-1',
          title: this.local.bankruptcy.bankruptcyFile.sessions.requestCircleSessions,
          role: 'requestCircleSessions',
          isEnabled: true,
        },
        {
          href: '#tab-2',
          title: this.local.bankruptcy.bankruptcyFile.sessions.requestElitigationSessions,
          role: 'requestElitigationSessions',
          isEnabled: this.elitigationSessionsEnabled,
        },
      ].filter(tab => tab.isEnabled);
    },
  },
  watch: {
    sessions: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.sessions = newValue;
      },
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions(['getSessionsByRequestObjectKey',
      'getSessionsByRequestObjectKey', 'getELitigationSessionsByRequestObjectKey', 'checkCanAccessElitigationSessions']),
    showELitigationSession(session) {
      this.$router.push({ path: '/bankruptcy/bankruptcy-file/' + this.requestObjectKey + '/elitigation-sessions/' + session.objectKey });
    },
    validateCanAttendRequestElitigationSessions(requestObjectKey) {
      this.loading = true;
      this.checkCanAccessElitigationSessions(requestObjectKey)
        .then((res) => {
          this.elitigationSessionsEnabled = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeTab(tab) {
      if (tab != this.selectedTab) {
        this.selectedTab = tab;
        if (tab.role == 'requestCircleSessions') {
          this.getSessionsByRequestObjectKey(this.requestObjectKey)
            .then((res) => {
              this.sessions = res.data;
            })
            .finally(() => {
              this.loading = false;
            });
        }
        else if (tab.role == 'requestElitigationSessions') {
          this.getELitigationSessionsByRequestObjectKey(this.requestObjectKey)
            .then((res) => {
              this.sessions = res.data;
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
    },
    loadData() {
      this.loading = true;
      this.validateCanAttendRequestElitigationSessions(this.requestObjectKey);
      this.getSessionsByRequestObjectKey(this.requestObjectKey)
        .then((res) => {
          this.sessions = res.data;
          this.selectedTab = this.tabsButtons[0];
        })
        .finally(() => {
          this.loading = false;
        });

    },
    //tO DO WAITING Pega
    viewAttachment(session) {
      return;
      // this.selectedFile = session;
      // this.$nextTick(() => {
      //   var modal = this.$refs.pdfModal;
      //   modal.showModal();
      // });
    },
    hideViewAttachmentModal() {
      this.selectedFile = null;
    },
    async copyURL(videoConferenceUrl) {
      if (videoConferenceUrl) {
        await navigator.clipboard.writeText(videoConferenceUrl);
        this.toaster.success(this.local.home.upcomingSessions.copied);
      }
    },
  },
};

</script>

<style lang="scss" scoped>
.copy-icon {
  font-size: 20px;
}
.videoConferenceUrl {
  color: #158e8d;
  cursor: pointer;
}

.header-text {
  font-weight: normal;
  font-size: 18px;
  color: var(--app-dark-primary-color);
}

.text-c-green {
  color: var(--app-primary-color);
}


.text-c-lite {
  color: #a6b8bb;
  font-weight: bold;
}

.text-info-value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: bold;
}

::v-deep .case-update-card-header {
  color: var(--app-dark-primary-color);
  font-size: 25px;
}

.pleading-action {
  &::v-deep .theme--light.v-btn.v-btn--outlined.v-btn--text {
    border-color: red;
  }
}
.cursor-pointer {
  cursor: pointer;
}
.attendanceRegister-title-header {
  color: #707070;
  font-size: 16px;
}
.attendanceRegister-title-condition {
  color: var(--app-lighter-primary-color);
  font-size: 18px;
  margin: 12px;
  text-align: right;
}
.text-condition {
  color: var(--app-dark-primary-color);
  font-size: 16px;
}

.text-c-lite {
  color: #a6b8bb;
}

.tab-padding {
  font-size: 16px;
  padding-bottom: 20px;
  color: var(--app-dark-primary-color) !important;
  .v-chip {
    cursor: pointer;
    color: #ffffff;
    background: var(--app-dark-primary-color) !important;
    border-radius: 0px !important;
  }
}
.tab-active {
  color: var(--app-primary-color) !important;
  font-weight: bold;

  .v-chip {
    background: var(--app-lighter-primary-color) !important;
  }
}

::v-deep .v-tabs {
  border-bottom: 1px solid #dbdbdb;
  .v-tabs-bar {
    .v-tabs-slider-wrapper {
      height: 3px !important;
    }
  }
}
::v-deep .v-tab {
  max-width: unset;
}
</style>
